<div class="dropdown">
    <button type="button" id="property-search-filter-dropdown" class="btn btn-ms-secondary dropdown-toggle"
        data-bs-auto-close="outside" data-bs-toggle="dropdown" aria-expanded="false">
        <fa-duotone-icon icon="filter" secondaryOpacity="0.6" class="fs-6 d-none d-sm-inline" />
        Filter
        @if (filterCount > 0) {
        <span
            class="position-absolute top-0 start-0 translate-middle badge border rounded-circle filter-count">{{filterCount}}</span>
        }
    </button>

    <!--begin::Menu 1-->
    <div ms-parent-focus [alwaysFocusOnRemoval]="true" class="dropdown-menu" (keyup.control.enter)="onApply()">

        <!--begin::Header-->
        <div class="fs-5 fw-bold px-3 py-2">Filter Options</div>
        <!--end::Header-->

        <!--begin::Separator-->
        <div class="separator border-gray-200"></div>
        <!--end::Separator-->

        <!--begin::Content-->

        <!-- Title Input with Add Button -->
        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Title:</label>
            <div class="input-group">
                <input type="text" class="form-control form-control-solid" placeholder="Enter title"
                    [(ngModel)]="titleInput" (keyup.enter)="addTitle()" />
                <button class="btn btn-primary px-3" type="button" (click)="addTitle()">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" />
                </button>
            </div>
            <div class="d-flex flex-wrap w-100">
                <!-- Display added title -->
                @if (activeFilter.titles && activeFilter.titles.length > 0) {
                <div class="mt-2">
                    @for (title of activeFilter.titles; track $index) {
                    <button class="tag-filter btn btn-primary" type="button" (click)="removeTitle($index)">{{title}}
                        <fa-duotone-icon icon="minus" secondaryOpacity="0.9" />
                    </button>
                    }
                </div>
                }
            </div>
        </div>

        <!-- Addresses Input with Add Button -->
        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Address Line 1:</label>
            <div class="input-group">
                <input type="text" class="form-control form-control-solid" placeholder="Enter address line 1"
                    [(ngModel)]="primaryAddressInput" (keyup.enter)="addPrimaryAddress()" />
                <button class="btn btn-primary px-3" type="button" (click)="addPrimaryAddress()">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" />
                </button>
            </div>
            <div class="d-flex flex-wrap w-100">
                <!-- Display added address -->
                @if (activeFilter.primaryAddresses && activeFilter.primaryAddresses.length > 0) {
                <div class="mt-2">
                    @for (address of activeFilter.primaryAddresses; track $index) {
                    <button class="tag-filter btn btn-primary" type="button"
                        (click)="removePrimaryAddress($index)">{{address}}
                        <fa-duotone-icon icon="minus" secondaryOpacity="0.9" />
                    </button>
                    }
                </div>
                }
            </div>
        </div>

        <!-- Addresses Input with Add Button -->
        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Address Line 2:</label>
            <div class="input-group">
                <input type="text" class="form-control form-control-solid" placeholder="Enter address line 2"
                    [(ngModel)]="secondaryAddressInput" (keyup.enter)="addSecondaryAddress()" />
                <button class="btn btn-primary px-3" type="button" (click)="addSecondaryAddress()">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" />
                </button>
            </div>
            <div class="d-flex flex-wrap w-100">
                <!-- Display added address -->
                @if (activeFilter.secondaryAddresses && activeFilter.secondaryAddresses.length > 0) {
                <div class="mt-2">
                    @for (address of activeFilter.secondaryAddresses; track $index) {
                    <button class="tag-filter btn btn-primary" type="button"
                        (click)="removeSecondaryAddress($index)">{{address}}
                        <fa-duotone-icon icon="minus" secondaryOpacity="0.9" />
                    </button>
                    }
                </div>
                }
            </div>
        </div>

        <!-- LotNumber Input with Add Button -->
        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Lot Number:</label>
            <div class="input-group">
                <input type="text" class="form-control form-control-solid" placeholder="Enter lot number"
                    [(ngModel)]="lotNumberInput" (keyup.enter)="addLotNumber()" />
                <button class="btn btn-primary px-3" type="button" (click)="addLotNumber()">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" />
                </button>
            </div>
            <div class="d-flex flex-wrap w-100">
                <!-- Display added lot number -->
                @if (activeFilter.lotNumbers && activeFilter.lotNumbers.length > 0) {
                <div class="mt-2">
                    @for (lotNumber of activeFilter.lotNumbers; track $index) {
                    <button class="tag-filter btn btn-primary" type="button"
                        (click)="removeLotNumber($index)">{{lotNumber}}
                        <fa-duotone-icon icon="minus" secondaryOpacity="0.9" />
                    </button>
                    }
                </div>
                }
            </div>
        </div>

        <!-- City Input with Add Button -->
        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">City:</label>
            <div class="input-group">
                <input type="text" class="form-control form-control-solid" placeholder="Enter city"
                    [(ngModel)]="cityInput" (keyup.enter)="addCity()" />
                <button class="btn btn-primary px-3" type="button" (click)="addCity()">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" />
                </button>
            </div>
            <div class="d-flex flex-wrap w-100">
                <!-- Display added title -->
                @if (activeFilter.cities && activeFilter.cities.length > 0) {
                <div class="mt-2">
                    @for (city of activeFilter.cities; track $index) {
                    <button class="tag-filter btn btn-primary" type="button" (click)="removeCity($index)">{{city}}
                        <fa-duotone-icon icon="minus" secondaryOpacity="0.9" />
                    </button>
                    }
                </div>
                }
            </div>
        </div>

        <!-- State Input with Add Button -->
        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">State / Province:</label>
            <div class="input-group">
                <input type="text" class="form-control form-control-solid" placeholder="Enter state / province"
                    [(ngModel)]="stateProvinceInput" (keyup.enter)="addStateProvince()" />
                <button class="btn btn-primary px-3" type="button" (click)="addStateProvince()">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" />
                </button>
            </div>
            <div class="d-flex flex-wrap w-100">
                <!-- Display added title -->
                @if (activeFilter.stateProvinces && activeFilter.stateProvinces.length > 0) {
                <div class="mt-2">
                    @for (stateProvince of activeFilter.stateProvinces; track $index) {
                    <button class="tag-filter btn btn-primary" type="button"
                        (click)="removeStateProvince($index)">{{stateProvince}}
                        <fa-duotone-icon icon="minus" secondaryOpacity="0.9" />
                    </button>
                    }
                </div>
                }
            </div>
        </div>

        <!-- Zip Input with Add Button -->
        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Zip:</label>
            <div class="input-group">
                <input type="text" class="form-control form-control-solid" placeholder="Enter zip"
                    [(ngModel)]="zipCodeInput" (keyup.enter)="addPrimaryZip()" />
                <button class="btn btn-primary px-3" type="button" (click)="addPrimaryZip()">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" />
                </button>
            </div>
            <div class="d-flex flex-wrap w-100">
                <!-- Display added title -->
                @if (activeFilter.primaryZips && activeFilter.primaryZips.length > 0) {
                <div class="mt-2">
                    @for (zip of activeFilter.primaryZips; track $index) {
                    <button class="tag-filter btn btn-primary" type="button" (click)="removePrimaryZip($index)">{{zip}}
                        <fa-duotone-icon icon="minus" secondaryOpacity="0.9" />
                    </button>
                    }
                </div>
                }
            </div>
        </div>

        <!-- Country Input with Add Button -->
        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Country:</label>
            <div class="input-group">
                <input type="text" class="form-control form-control-solid" placeholder="Enter country"
                    [(ngModel)]="countryInput" (keyup.enter)="addCountry()" />
                <button class="btn btn-primary px-3" type="button" (click)="addCountry()">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" />
                </button>
            </div>
            <div class="d-flex flex-wrap w-100">
                <!-- Display added title -->
                @if (activeFilter.countries && activeFilter.countries.length > 0) {
                <div class="mt-2">
                    @for (country of activeFilter.countries; track $index) {
                    <button class="tag-filter btn btn-primary" type="button" (click)="removeCountry($index)">{{country}}
                        <fa-duotone-icon icon="minus" secondaryOpacity="0.9" />
                    </button>
                    }
                </div>
                }
            </div>
        </div>

        <!-- Member Count Input with Add Button -->
        <div class="mb-2 px-3 py-2 mw-100">
            <label class="form-label fw-semibold">Member Count:</label>
            <div class="row">
                <div class="col-6">
                    <input type="number" class="form-control form-control-solid" placeholder="Min"
                        [(ngModel)]="minMemberCountInput" (change)="onMinMemberCountChange()" />
                </div>
                <div class="col-6">
                    <input type="number" class="form-control form-control-solid" placeholder="Max"
                        [(ngModel)]="maxMemberCountInput" (change)="onMaxMemberCountChange()" />
                </div>
            </div>
        </div>

        <!--begin::Multi-select Input group-->
        @if (!hideStatusFilter()) {
        <div class="mb-2 px-3 py-2">
            <label class="form-label fw-semibold">Property Status:</label>
            <ms-multi-select placeholder="Select Status" [options]="selectPropertyStatusOptions"
                [(selectedOptions)]="selectedPropertyStatus" (selectionChange)="onStatusChange($event)" />
        </div>
        }
        <!--end::Multi-select Input group-->

        <!--begin::Actions-->
        <div class="d-flex justify-content-end px-3 py-2">
            <button type="button" class="btn btn-ms-secondary reset-filter-button me-2 px-6"
                (click)="onReset()">Reset</button>
            <button type="button" class="btn btn-primary px-6" (click)="onApply()">Apply</button>
        </div>
        <!--end::Actions-->

        <!--end::Content-->
    </div>
    <!--end::Menu 1-->
</div>